var _path, _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomToRouteWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.515 8.33203H14.2337H14.7125C15.2245 8.33203 15.7085 8.56556 16.0271 8.9663V8.9663C16.4927 9.55195 16.5147 10.375 16.081 10.9847L16.0291 11.0578C15.7115 11.5043 15.1973 11.7696 14.6493 11.7696H14.2337H14.2127H13.1479C12.8858 11.7696 12.6733 11.982 12.6733 12.2442V12.2442C12.6733 12.5063 12.4609 12.7187 12.1988 12.7187H11.6286H10.7788H9.91116C9.63224 12.7187 9.36085 12.8092 9.13771 12.9766V12.9766C8.4502 13.4922 8.4502 14.5235 9.13771 15.0391V15.0391C9.36085 15.2064 9.63224 15.2969 9.91116 15.2969H10.7384H16.3694H16.7991",
    stroke: "white",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4320_33275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 11,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.68631,
    height: 9.68205,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 11.3457 3.96191)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4320_33275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1268 5.34263H6.14077V11.3287",
    stroke: "white",
    strokeWidth: 0.9
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4320_33275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 1,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.68631,
    height: 9.68205,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 20.249 10.5615)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4320_33275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8683 11.3417L18.8683 5.35561L12.8823 5.35561",
    stroke: "white",
    strokeWidth: 0.9
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4320_33275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 12,
    width: 11,
    height: 11
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.68631,
    height: 9.68205,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 13.6553 19.4629)",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4320_33275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8751 18.0822H18.8612V12.0961",
    stroke: "white",
    strokeWidth: 0.9
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4320_33275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 12,
    width: 10,
    height: 11
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.68631,
    height: 9.68205,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 4.75195 12.8682)",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4320_33275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13267 12.0871L6.13267 18.0731L12.1187 18.0731",
    stroke: "white",
    strokeWidth: 0.9
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9692 8.4695C10.8744 8.96888 10.2244 10.0468 9.87477 10.5606C9.52194 10.0424 8.84214 8.87498 8.7818 8.4695C8.67679 7.76379 9.12326 7.16903 9.88089 7.16895C10.6385 7.16886 11.0971 7.79602 10.9692 8.4695Z",
    stroke: "white",
    strokeWidth: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.3875,
    y1: 13.168,
    x2: 16.3875,
    y2: 15.7502,
    stroke: "white",
    strokeWidth: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomToRouteWhite);
export default __webpack_public_path__ + "static/media/zoomToRouteWhite.266ba6958329ced476a2dd7ed7a779a5.svg";
export { ForwardRef as ReactComponent };